<template>
	<div class="tree-menu .menu table">
		<table>

			<thead v-if="isFirst">
				<tr>
					<th><span></span></th>
					<th>Curadoria</th>
					<th>Curador</th>
					<th>Ações</th>
				</tr>
			</thead>

			<tbody>
				<tr :style="indent" class="fields">
					<td v-if="nodes.length" v-on:click.stop="toggleChildren()">
						<i v-bind:class="[isOpen ? 'fas fa-minus' : 'fas fa-plus']"></i>
					</td>

					<td class="forbidden" v-else>
						<i class='fas fa-minus'></i>
					</td>

					<td>
						{{ codigo ? `${codigo.toUpperCase()} - ` : '' }} {{ label }}
						<span class="objectCount label">{{ objetosTotal ? `${objetosTotal} objetos cadastrados` : 'nenhum objeto cadastrado' }}</span>
					</td>

					<td>{{nomeUsuario}}</td>

					<td class="acoes">

						<div v-if="permiteManipulacao" class="btn-container">
							<span v-if="depth > 1" class="copy-id-obj">
								<copiar :button="true" :text="id" :hideText="true" iconText="ID"></copiar>
							</span>
								<button class="editar acao" @click="editarCuradoriaESubCuradoria(id, depth)">
									<i class="fas fa-pencil-alt"></i>
								</button>
								<button class="depth" :class="[depth <= 1 ? '' : 'isOpacity']" @click="[depth <= 1 ? adicionarSubCuradoria(id) : '']">
									<i class="fas fa-level-up-alt"></i>
									SubCuradoria
								</button>
								<button-remove :totalObjetos="objetosTotal" :nomeUsuario="nomeUsuario" :onClick="() => selectCuradoriaHandler(id, label)"/>
						</div>

					<!-- quando não permite manipulação de elementos, a única ação disponível é copiar o ID -->
						<div v-else class="btn-container">
							<span v-if="depth > 1" class="copy-id-obj">
								<copiar :button="true" :text="id" :hideText="true" iconText="ID"></copiar>
							</span>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
		<div class="childList" v-if="showChildren">
			<SubCuradorias v-for="(node, index) in nodes" :permiteManipulacao="permiteManipulacao" :key="index" :selectCuradoriaHandler="selectCuradoriaHandler"
			:nomeUsuario="node.nomeUsuario" :objetosTotal="node.objetosTotal" :nodes="node.subCuradorias" :depth="depth + 1"
			:id="node.id" :label="node.nome" />
		</div>
  </div>
</template>

<script>
import SubCuradorias from './SubCuradorias'
import Copiar from './Copiar'
import EventBus from '@/components/event-bus.js'
import ButtonRemove from '@/components/shared/ButtonRemove'

export default {
	name: 'SubCuradorias',
	components: { SubCuradorias, ButtonRemove, Copiar },
	props: ['nodes', 'label', 'id', 'depth', 'nomeUsuario', 'objetosTotal', 'selectCuradoriaHandler', 'codigo', 'permiteManipulacao', 'isFirst'],
	data () {
		return {
			showChildren: false,
			isOpen: false
		}
	},
	computed: {
		indent () {
			return { transform: `translate(${this.depth * 30}px)` }
		},
		tamanho () {
			// const tamanho = 700 - (this.depth * 30)
			const tamanho = 550 - (this.depth * 30)
			return { width: `${tamanho}px` }
		}
	},
	methods: {
		adicionarSubCuradoria (id) {
			const payLoad = { id }
			EventBus.$emit('salvar-curadoria', payLoad)

			EventBus.$on('reposta-cadastro-curadoria', async () => {
				this.showChildren = !this.showChildren
				this.isOpen = !this.isOpen
			})
		},
		// salvarTeclaEnter(e) {
		// 	console.log('fdsfds', e)
		// },
		editarCuradoriaESubCuradoria (id, depth) {
			const payLoad = { id, depth }
			EventBus.$emit('editar-curadoria-subCuradoria', payLoad)
		},
		toggleChildren () {
			this.showChildren = this.isOpen = !this.showChildren
		}
	}
}
</script>

<style lang="scss" scoped>

	@mixin td-th-width {
		&:nth-child(1) {
			width: 5%;
		}
		&:nth-child(2) {
			width: 45%;
			text-align: left;
		}
		&:nth-child(3) {
			width: 25%;
			text-align: center;
		}
		&:nth-child(4) {
			width: 25%;
		}
	}

.tree-menu {
	background-color: inherit;
	&:nth-child(n) {
		margin-bottom: 0px;
	}
	&.table {
		background-color: transparent;
		padding: 0px;
		table {
			border-spacing: 0px 5px;
			thead {
				tr {
					th {
						@include td-th-width();
					}
				}
			}
			tbody{
				tr {
					text-align: left;
					padding: 5px;

					td {
						@include td-th-width();
						vertical-align: middle;
						padding: 10px 5px;
						font-weight: 100;

						&:first-child {
							padding-left: 5px;
							color: #fff;
							margin: 5px;
							cursor: pointer;

							&.forbidden {
								cursor: not-allowed;
								opacity: .3;
							}

							i {
									color: $main-color;
									font-size: 13px;
									height: 20px;
									width: 25px;
									display: flex;
									justify-content: center;
									align-items: center;
									margin-right: 3px;
							}
						}

						.btn-container {
							button {
								border: none;
								&:not(:disabled) {
									cursor: pointer;
								}
								&.depth {
									background-color: $main-color;
									width: auto;
									.fa-level-up-alt {
										margin-right: 6px;
										font-size: 13px;
										transform: rotate(90deg);
									}
								}
							}
						}

						.label {
							display: inline-block;
							padding: 2px 10px;
							margin-left: 5px;
							border-radius: 20px;
							background-color: #E8E8E8;
							font-size: .8em;
						}
					}
				}
			}
		}
	}

	.tree-menu {
		font-size: inherit;

		table {
			margin-bottom: 5px;

			tbody{

				tr {
					border-radius: 4px;

					td {
						padding-top: 4px;
						padding-bottom: 4px;

						button {
							display: flex;
							align-items: center;
							height: 30px;
							margin-bottom: 3px;
						}
					}
				}
			}
		}
	}
	.isOpacity {
		opacity: 0.5;
	}
}

.childList .tree-menu {
	margin-right: 30px;
}

.flex {
	display: flex;
	justify-content: flex-end;
}
</style>
